import { useState, useEffect, useCallback, useRef } from 'react';
import { NavLink} from 'react-router-dom';
import logoMenu from '../../assets/pictures/logo-2024.png';
import './mobile.scss';
import SignIn from '../../painel/signIn/singIn-admin';

export default function Navbar() {
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen((prev) => !prev);
  };

  const hasFocus = (target) => {
    if(!dropdownRef.current){
      return false;
    }

    let dropdownHasFocus = false;
    const nodeIterator = document.createNodeIterator(dropdownRef.current, NodeFilter.SHOW_ELEMENT, null, false);
    let node;

    while ((node = nodeIterator.nextNode())){
      if(node === target){
        dropdownHasFocus = true;
        break;
      }
    }

    return dropdownHasFocus;
  };

  const handleBlurEvent = (e) => {
    if(!hasFocus(e.relatedTarget)){
      setIsDropdownOpen(false);
    }
  }

  const handleMouseEvent = (e) => {
    if(!hasFocus(e.target)){
      setIsDropdownOpen(false);
    }
  }

  // funcção para fechar submenu ao ser clicado
  const handleMenuItemclick = () =>{
    setIsDropdownOpen(false);
    setIsNavExpanded(false);
  }

  const handleNavItem = () => {
    setIsNavExpanded(false);
  }

  const handleScroll = useCallback(() => {
    const navBar = document.querySelector(".navigation");

    if (window.scrollY > 10) {
      navBar.classList.add('scrolled');
      navBar.classList.add('fixed');
    } else {
      navBar.classList.remove('scrolled');
      navBar.classList.remove('fixed');
      navBar.classList.add('container');
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.scrollTo(0, 0);

    document.addEventListener('mouseup', handleMouseEvent);
    if(dropdownRef.current){
      dropdownRef.current.addEventListener('focusout', handleBlurEvent);
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener('mouseup', handleMouseEvent);
      if(dropdownRef.current){
        // eslint-disable-next-line react-hooks/exhaustive-deps
        dropdownRef.current.removeEventListener('focusout', handleBlurEvent);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleScroll]);

  return (
    <section className="section-navigation">
      <nav className="navigation container">
        <div className="brand-name" data-aos="fade-in" data-aos-duration="2000">
          <a href='/'>
            <img src={logoMenu} alt="logo" />
          </a>
        </div>
        <button
          className="hamburger"
          onClick={() => setIsNavExpanded(!isNavExpanded)}
          aria-label="Toggle menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="white"
          >
            {isNavExpanded ? (
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            ) : (
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
                clipRule="evenodd"
              />
            )}
          </svg>
        </button>
        <div className={isNavExpanded ? 'navigation-menu expanded' : 'navigation-menu'}>
          <ul>
            <li><NavLink to="/" onClick={handleNavItem}>Início</NavLink></li>
            <li className={`dropdown ${isDropdownOpen ? 'show' : ''}`} ref={dropdownRef}>
              <NavLink to="#!" onClick={toggleDropdown} className="dropdown-toggle">
                Constitucional
              </NavLink>
              {isDropdownOpen && (
                <ul className='dropdown-menu'>
                  <li><NavLink to="/sobre" onClick={handleMenuItemclick}>Sobre</NavLink></li>
                  <li><NavLink to="/ouvidoria" onClick={handleMenuItemclick}>Ouvidoria</NavLink></li>
                  <li><NavLink to="/trabalheconosco" onClick={handleMenuItemclick}>Trabalhe Conosco</NavLink></li>
                  <li><NavLink to="/conheca-a-seculos" onClick={handleMenuItemclick}>Conheça a Séculos</NavLink></li>
                  <li><NavLink to="/painel/sign-admin" onClick={SignIn}>Seculos Web</NavLink></li>
                </ul>
              )}
            </li>
            <li><NavLink to="/servicos" onClick={handleNavItem}>Serviços</NavLink></li>
            <li><NavLink to="/artigos" onClick={handleNavItem}>Artigos</NavLink></li>
            <li><NavLink to="/projetos" onClick={handleNavItem}>Projetos</NavLink></li>
            <li><NavLink to="/contato" onClick={handleNavItem}>Contato</NavLink></li>
            <li><a href='https://gruposeculos.com.br/files/portfolio.pdf' download target='_blank' rel="noreferrer">Portfólio</a></li>
          </ul>
        </div>
      </nav>
    </section>
  );
}
